import { Flexi } from "slotworks/graphics/elements/abstract-flexi";
import ToggleElement from "slotworks/graphics/elements/toggle-element";

export default class FlexiToggle extends Flexi<HTMLElement | ToggleElement> {

    private sharedValue: boolean = false;

    public addTarget(target: HTMLElement | ToggleElement) {
        super.addTarget(target);

        if (target) {
            if (target instanceof HTMLElement) {
                const checkBox = target as HTMLInputElement;
                target.addEventListener("change", () => this.setValue(checkBox.checked));
            } else if (target instanceof ToggleElement) {
                const checkBox = target as ToggleElement;
                checkBox.onChanged.add(() => this.setValue(checkBox.getChecked()));
            }
        }
    }

    public on(event: ToggleEvent, handler: Function) {
        for (const target of this.targets) {
            if (target instanceof HTMLElement) {
                target.addEventListener(event.id, handler as any);
            } else if (target instanceof ToggleElement) {
                if (event.id === ToggleEvent.CHANGE.id) {
                    target.onChanged.add(handler);
                }
            }
        }
    }

    public off(event: ToggleEvent, handler: Function) {
        for (const target of this.targets) {
            if (target instanceof HTMLElement) {
                target.removeEventListener(event.id, handler as any);
            } else if (target instanceof ToggleElement) {
                if (event.id === ToggleEvent.CHANGE.id) {
                    target.onChanged.remove(handler);
                }
            }
        }
    }

    public setValue(value: boolean) {
        this.sharedValue = value;

        for (const target of this.targets) {
            if (target instanceof HTMLElement) {
                (target as HTMLInputElement).checked = value;
            } else if (target instanceof ToggleElement) {
                target.setChecked(value);
            }
        }
    }

    public getValue(): boolean {
        return this.sharedValue;
    }

    public setVisible(visible: boolean) {
        for (const target of this.targets) {
            if (target instanceof HTMLElement) {
                target.classList.toggle("visible", visible);
                target.classList.toggle("hidden", !visible);
            } else if (target instanceof ToggleElement) {
                target.setVisible(visible);
            }
        }
    }

    public setEnabled(enabled: boolean) {
        for (const target of this.targets) {
            if (target instanceof HTMLElement) {
                target.classList.toggle("enabled", enabled);
                target.classList.toggle("disabled", !enabled);
            } else if (target instanceof ToggleElement) {
                target.setEnabled(enabled);
            }
        }
    }
}

export class ToggleEvent {
    public static CHANGE: ToggleEvent = new ToggleEvent("change");

    public id: string;

    constructor(id: string) {
        this.id = id;
    }
}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/graphics/elements/flexi-toggle.ts